 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","boards":"boards","code~projects":"code~projects","code":"code","projects":"projects","libs":"libs","serial-base":"serial-base","serial-nav-app":"serial-nav-app","servers":"servers","settings":"settings"}[chunkId]||chunkId) + "." + {"about":"7649115c","boards":"081d3367","chunk-155268a8":"311d090d","chunk-2d0a3149":"094e76c5","chunk-2d0a32e7":"ac360bda","chunk-2d0a3e89":"82a48933","chunk-2d0a4b4f":"d52e1b77","chunk-2d0a4f3d":"433dcb86","chunk-2d0aa633":"f0829257","chunk-2d0aabd6":"9c1abc8c","chunk-2d0ac354":"d631f3c2","chunk-2d0b16cd":"141bbdec","chunk-2d0b218a":"10c23c22","chunk-2d0b2725":"ecc68932","chunk-2d0b5f38":"e1b1eedf","chunk-2d0b5fd1":"cc12ef6f","chunk-2d0b654b":"080e6eb8","chunk-2d0c06a5":"bab33c6f","chunk-2d0c4db7":"fdb375fd","chunk-2d0c512b":"df38be1b","chunk-2d0c515d":"de740367","chunk-2d0cb76d":"15717240","chunk-2d0d0474":"5c502aaf","chunk-2d0d2b72":"30d6b66c","chunk-2d0d2e88":"7ab5ca90","chunk-2d0d6e5d":"0defab24","chunk-2d0d7804":"59bdd992","chunk-2d0daf4f":"d72c3c68","chunk-2d0db816":"b189581c","chunk-2d0dd64f":"5479f907","chunk-2d0dd7df":"78d70615","chunk-2d0e22d6":"ac8be92d","chunk-2d0e4510":"0fed0f84","chunk-2d0e5949":"d3a5bd97","chunk-2d0e5985":"5075be6c","chunk-2d0e59b0":"14b756d1","chunk-2d0e883d":"a0b5bc30","chunk-2d0e8e3f":"f7c7969c","chunk-2d2076e9":"d42340c3","chunk-2d2077f0":"4fcd322e","chunk-2d207ba3":"899c3ad8","chunk-2d208d9e":"4cdd3394","chunk-2d20ed73":"e4897f04","chunk-2d20ee04":"07c8d388","chunk-2d210627":"c5d66ff6","chunk-2d212fb6":"02c742ea","chunk-2d213185":"9ee80813","chunk-2d21449a":"7a446f52","chunk-2d21684f":"e6b4f989","chunk-2d217118":"be0a348b","chunk-2d2172c8":"668c9130","chunk-2d2174db":"a8537f83","chunk-2d217aa9":"995bf10a","chunk-2d21dc90":"dbfed850","chunk-2d21e73c":"8423439c","chunk-2d21e957":"0f9eac08","chunk-2d222cf8":"2d401039","chunk-2d225f5a":"775bb7b8","chunk-2d22691a":"31ef71e1","chunk-2d229b9a":"fc1c3d50","chunk-2d22d0b0":"55b6025a","chunk-2d23055f":"03b4130b","chunk-2d230c43":"a76be69e","chunk-2d230e24":"c50f8f5e","chunk-2d237b6e":"00d4390e","chunk-2d238498":"16b851e4","chunk-34e4b8d2":"58bc8689","chunk-51826664":"8ca04395","chunk-98234524":"c26f66a7","code~projects":"ad2b75ce","code":"a4263bdc","projects":"b497a134","libs":"c90d2a74","serial-base":"e0ba29b5","serial-nav-app":"22246d17","servers":"bd0afe4a","settings":"082acbe6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"code~projects":1,"code":1,"libs":1,"servers":1,"settings":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","boards":"boards","code~projects":"code~projects","code":"code","projects":"projects","libs":"libs","serial-base":"serial-base","serial-nav-app":"serial-nav-app","servers":"servers","settings":"settings"}[chunkId]||chunkId) + "." + {"about":"31d6cfe0","boards":"31d6cfe0","chunk-155268a8":"31d6cfe0","chunk-2d0a3149":"31d6cfe0","chunk-2d0a32e7":"31d6cfe0","chunk-2d0a3e89":"31d6cfe0","chunk-2d0a4b4f":"31d6cfe0","chunk-2d0a4f3d":"31d6cfe0","chunk-2d0aa633":"31d6cfe0","chunk-2d0aabd6":"31d6cfe0","chunk-2d0ac354":"31d6cfe0","chunk-2d0b16cd":"31d6cfe0","chunk-2d0b218a":"31d6cfe0","chunk-2d0b2725":"31d6cfe0","chunk-2d0b5f38":"31d6cfe0","chunk-2d0b5fd1":"31d6cfe0","chunk-2d0b654b":"31d6cfe0","chunk-2d0c06a5":"31d6cfe0","chunk-2d0c4db7":"31d6cfe0","chunk-2d0c512b":"31d6cfe0","chunk-2d0c515d":"31d6cfe0","chunk-2d0cb76d":"31d6cfe0","chunk-2d0d0474":"31d6cfe0","chunk-2d0d2b72":"31d6cfe0","chunk-2d0d2e88":"31d6cfe0","chunk-2d0d6e5d":"31d6cfe0","chunk-2d0d7804":"31d6cfe0","chunk-2d0daf4f":"31d6cfe0","chunk-2d0db816":"31d6cfe0","chunk-2d0dd64f":"31d6cfe0","chunk-2d0dd7df":"31d6cfe0","chunk-2d0e22d6":"31d6cfe0","chunk-2d0e4510":"31d6cfe0","chunk-2d0e5949":"31d6cfe0","chunk-2d0e5985":"31d6cfe0","chunk-2d0e59b0":"31d6cfe0","chunk-2d0e883d":"31d6cfe0","chunk-2d0e8e3f":"31d6cfe0","chunk-2d2076e9":"31d6cfe0","chunk-2d2077f0":"31d6cfe0","chunk-2d207ba3":"31d6cfe0","chunk-2d208d9e":"31d6cfe0","chunk-2d20ed73":"31d6cfe0","chunk-2d20ee04":"31d6cfe0","chunk-2d210627":"31d6cfe0","chunk-2d212fb6":"31d6cfe0","chunk-2d213185":"31d6cfe0","chunk-2d21449a":"31d6cfe0","chunk-2d21684f":"31d6cfe0","chunk-2d217118":"31d6cfe0","chunk-2d2172c8":"31d6cfe0","chunk-2d2174db":"31d6cfe0","chunk-2d217aa9":"31d6cfe0","chunk-2d21dc90":"31d6cfe0","chunk-2d21e73c":"31d6cfe0","chunk-2d21e957":"31d6cfe0","chunk-2d222cf8":"31d6cfe0","chunk-2d225f5a":"31d6cfe0","chunk-2d22691a":"31d6cfe0","chunk-2d229b9a":"31d6cfe0","chunk-2d22d0b0":"31d6cfe0","chunk-2d23055f":"31d6cfe0","chunk-2d230c43":"31d6cfe0","chunk-2d230e24":"31d6cfe0","chunk-2d237b6e":"31d6cfe0","chunk-2d238498":"31d6cfe0","chunk-34e4b8d2":"31d6cfe0","chunk-51826664":"31d6cfe0","chunk-98234524":"31d6cfe0","code~projects":"a8cdaeae","code":"d27b3c8c","projects":"31d6cfe0","libs":"287012ac","serial-base":"31d6cfe0","serial-nav-app":"31d6cfe0","servers":"c03ecf39","settings":"ab36dd47"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
